export const namingSchemas = [
  {label: '1 to 5', value: 'OneToFive'},
  {label: '1 to 3', value: 'OneToThree'},
  {label: 'Yes / No', value: 'YesNo'},
  {label: 'Pass / Fail', value: 'PassFail'},
  {label: '1 to 2', value: 'OneTwo'},
];
